import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'general-policy-pl',
    templateUrl: './general-policy-pl.component.html',
    styleUrls: ['./general-policy-pl.component.scss']
})
export class GeneralPolicyPlComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
